import { styled } from '../../../../../../theme/styled';
import { TextInputStateProps } from '../model';

export const TextInputRoot = styled('div', {
  name: 'TextInput',
  slot: 'Root',
})<{ ownerState: Required<TextInputStateProps> }>(({ theme, ownerState }) => {
  const { error, disabled, focused, size, startAdornment, endAdornment } = ownerState;

  const px = { 'small': 13, 'normal': 24 }[size];

  const borderColor = error ? theme.palette['brand pink'] : theme.palette['gray light'];
  const borderRadius = theme.borderRadius.normal;

  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    paddingRight: endAdornment ? 12 : px,
    paddingLeft: startAdornment ? 12 : px,
    border: `1px solid ${borderColor}`,
    borderRadius: `${borderRadius}px`,
    backgroundColor: 'white',
    '&:hover': {
      ...(!error &&
        !disabled && {
          borderColor: theme.palette.gray,
        }),
    },
    ...(focused
      ? {
          outline: 'none',
          ...(!error &&
            !disabled && {
              borderColor: theme.palette['brand gray'],
            }),
        }
      : undefined),
  };
});
